import { SubscriptionFeature } from "../../../types/billing/SubscriptionFeature";

export const integratonsFeatures: SubscriptionFeature[] = [
    SubscriptionFeature.IntegrationsBloomberg,
    SubscriptionFeature.IntegrationsIntex,
    SubscriptionFeature.IntegrationsValitana
];
